import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const HomeRoutes = createFeatureRoutes(
  'home',
  {
    list: () => import('../presentation/pages/HomePage'),
    details: () => import('../presentation/pages/HomeDetails'),
    invoice: () => import('../presentation/pages/InvoiceDetails'),
    profile: () => import('@/common/presentation/pages/Profile'),
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'details', pageKey: 'details' },
    { path: 'invoice/:id', pageKey: 'invoice' },
    { path: 'profile', pageKey: 'profile' },
    { path: ':id', pageKey: 'details' },
  ],
);

export default HomeRoutes;
